<template>
    <div class="bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-4">

        <div class="flex items-start justify-between mb-6 p-2 rounded-xl bg-[#FFFFFF14]">
            <!-- Left Section -->
            <div class="flex items-start gap-4 ">
                <!-- iPhone Image -->
                <div class="bg-[#FFFFFF14] rounded-2xl p-1">
                    <NuxtImg src="/images/product-showcase/iphone.png" alt="iPhone 15" width="70" height="70" loading="lazy" />
                </div>

                <!-- Product Details -->
                <div class="flex flex-col">
                    <h2 class="text-[var(--text-secondary)] text-base mb-1">Iphone 15</h2>
                    <p class="text-[var(--text-gray)] text-xs mb-1">Model : Starlight | Qty : 2</p>
                    <p class="text-[var(--text-secondary)] text-base font-bold">$248,00</p>
                </div>
            </div>

            <!-- Status Badge -->
            <div class="bg-[#FFFFFF1A] text-[var(--text-secondary)] px-2 py-1 rounded-full text-xs">
                Delivered
            </div>
        </div>

        <!-- Review Button -->
        <div class="flex justify-center">
            <button
                class="bg-[var(--background-btn)] text-white px-6 py-3 rounded-lg font-medium text-sm hover:bg-[#4a5661] transition-colors">
                LEAVE A REVIEW
            </button>
        </div>
    </div>

</template>

<script setup lang="ts">
// No extra logic needed for now, static card
</script>
